import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-manage-facility',
  templateUrl: './manage-facility.component.html',
  styleUrls: ['./manage-facility.component.scss']
})
export class ManageFacilityComponent implements OnInit {

  showmyFilter:boolean = false;
  showAddfacility:boolean = false;

  constructor(private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  showFilter(){
    this.showmyFilter = !this.showmyFilter
  }

 
  sendRequest(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  openCaseDetail(){
    this.showAddfacility = true;
  }
  
  getCloseAddfacility(message){
    this.showAddfacility = message;
  }

  getCloseFilter(message){
    this.showmyFilter = message;
  }

  close() {
    this.dialog.closeAll();
  }

  

}
